/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Button } from "@nordcloud/gnui";
import { showSuccess } from "~/components";
import { useShowError } from "~/components/Error/useShowError";
import { PricingType } from "~/components/Services/PricingType";
import { SidebarTextField } from "~/components/SidebarForm/inputs/SidebarTextField";
import { SidebarForm } from "~/components/SidebarForm/SidebarForm";
import { SidebarFormButtons } from "~/components/SidebarForm/SidebarFormButtons";
import { PriceType } from "~/models";
import { ROUTES } from "~/routing";
import {
  generateActionSuccessText,
  itHasNotOnlyWhitespace,
  useAxios,
} from "~/tools";
import { maxLength } from "~/tools/validation/validators";

type Values = {
  name: string;
};

function ServiceAdd() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [pricingType, setPricingType] = React.useState(
    PriceType.CAPACITY_BASED_FEE
  );

  const methods = useForm();

  const history = useHistory();
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const onSubmit = async (values: Values) => {
    const organizeValues = { name: values.name, pricingType };
    try {
      const { data } = await Axios().post("/catalog/services", organizeValues);
      showSuccess(generateActionSuccessText(`Service`)()("added")());
      history.push(`${ROUTES.serviceCommitments.index}/${data.id}`);
    } catch (e) {
      showError(e.response);
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsSidebarOpen(true)}
        css={{ marginLeft: "auto" }}
        icon="plus"
      >
        Add new Service
      </Button>

      <SidebarForm
        width="32rem"
        title="Add new service"
        open={isSidebarOpen}
        setOpen={setIsSidebarOpen}
        formMethods={methods}
        submit={onSubmit}
      >
        <SidebarTextField
          name="name"
          label="Name"
          required
          registerOptions={{
            ...maxLength(255),
            validate: itHasNotOnlyWhitespace,
          }}
        />

        <PricingType
          setPricingType={setPricingType}
          pricingType={pricingType}
        />

        <SidebarFormButtons
          submitEnabled={!!methods.watch("name")}
          onCancel={() => setIsSidebarOpen(false)}
        />
      </SidebarForm>
    </>
  );
}

export { ServiceAdd };
